import { createApp } from 'vue';

// Wrap ResizeObserver so its callback runs inside requestAnimationFrame.
// This prevents the "ResizeObserver loop completed with undelivered notifications"
// error that Vuetify combobox/autocomplete components trigger during typing.
const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      requestAnimationFrame(() => { callback(entries, observer); });
    });
  }
};
// Scroll the focused element into view when navigating with Tab.
// Vuetify's layout can create a scroll container that isn't window, so the
// browser's built-in scroll-to-focus doesn't always fire.
let _lastKeyWasTab = false;
document.addEventListener('keydown', (e) => { _lastKeyWasTab = e.key === 'Tab'; }, { capture: true });
document.addEventListener('focusin', (e) => {
  if (_lastKeyWasTab && e.target && typeof e.target.scrollIntoView === 'function') {
    e.target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
}, { capture: true });

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { VTimePicker } from 'vuetify/labs/VTimePicker'
import '@mdi/font/css/materialdesignicons.css';

import App from './App.vue';

import { VueFire, VueFireFirestoreOptionsAPI } from 'vuefire';
import { db } from './firebaseConfig';

import router from './router'; // Import router
import { createPinia } from 'pinia';

import VueGoogleCharts from 'vue-google-charts';

//import mixins from './mixins'; // Import mixins
import { lengthToText } from '@/utils/globalFunctions'; // Import the function


const vuetify = createVuetify({
  components: {
    VTimePicker,
    ...components
  },
  directives,
  theme: {
    defaultTheme: 'pokerTheme',
    themes: {
      pokerTheme: {
        dark: false,
        colors: {
          primary:    '#2D6A4F',
          secondary:  '#E07A2F',
          background: '#FFFFFF',
          surface:    '#FFFFFF',
          error:      '#EF4444',
          success:    '#22C55E',
          warning:    '#F59E0B',
          info:       '#3B82F6',
        },
      },
    },
  },
});

const app = createApp(App);
const pinia = createPinia();
app.use(pinia);
app.use(router); // Use router
app.use(VueGoogleCharts);

app.use(VueFire, {
  firebaseApp: db,
  modules: [
    VueFireFirestoreOptionsAPI(),
  ]
});

app.config.globalProperties.$lengthToText = lengthToText;
app.use(vuetify);

router.isReady().then(() => {
  app.mount('#app');

  // Allow tournament notification sounds to play alongside background music on iOS.
  // 'ambient' mixes with other audio rather than interrupting it.
  // navigator.audioSession is Safari/iOS 16.4+ only — guard required.
  if ('audioSession' in navigator) {
    navigator.audioSession.type = 'ambient';
  }
});
